import ImageHeading from "../components/ui/ImageHeading";

import AnimatedQuote from "../components/ui/Card/AnimatedQuoteCard";
import LibraryHours from "../components/ui/Card/libraryHoursCard";
import LibraryRules from "../components/Library/LibraryRules";
import NewArrivalSlide from "../components/Library/NewArrivalSlide";

import bgimage from "../assets/bgImage.webp";

import ResourceGrid from "../components/ui/ResourceGrid";

import LibraryAmbitionCommitment from "./LibraryAmibitionCommitment";
import ResearchCTA from "../components/ui/ResearchCTA";
import useAxiosPublic from "../hooks/useAxiosPublic";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../components/Layout/LoadingPage";
import LibraryStats from "../components/Library/LibraryStats";

import libimg from "../assets/Jannnatul_Mawa_Mim.jpeg";

const Library = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: libraryApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["library-data"],
    queryFn: async () => {
      const res = await axiosPublic.get("/library");
      return res?.data;
    },
  });
  console.log(libraryApiData, "library data");

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }

  return (
    <div className="min-h-screen">
      <ImageHeading
        heading={libraryApiData?.hero?.title}
        imageUrl={libraryApiData?.hero?.media_url}
      />
      <div className="container mx-auto sm:px-6 lg:px-8">
        {/* quote */}
        <div className="">
          <AnimatedQuote
            author={libraryApiData?.library?.author}
            quote={libraryApiData?.library?.quote}
          />
        </div>
        <div className="my-12">
          <div>
            <h3 className="text-2xl font-bold text-black text-center lg:text-4xl font-domine">
              ZNRF University Digital Library
            </h3>

            <p className="py-6 leading-loose text-gray-700">
              ZUMS Library has launched a new digital library service using
              <span className="font-bold text-primary-500 ml-1">
                <a target="_blank" href="https://zumslibrary.librarika.com/">
                  Librarika
                </a>
              </span>
              , a cloud-based library management system. This new service
              enables users to search the library catalog online, check resource
              availability, and access library information easily. The
              initiative reflects ZUMS Library’s commitment to modern,
              user-friendly, and technology-driven library services.
            </p>
            <p className=" leading-loose text-gray-700">
              To access this service, all faculty and students must register
              using the Google Form provided. After registration, each member
              will receive a Library Membership ID and password, which must be
              used to log in to the digital library system. Membership
              credentials are personal and confidential, and any misuse may
              result in suspension of library privileges.
            </p>
          </div>
        </div>
        {/* new arrival */}
        <div className="my-8">
          <h3 className="text-2xl font-bold text-black lg:text-4xl font-domine">
            New Arrival
          </h3>
          <NewArrivalSlide data={libraryApiData?.library?.new_arrival} />
        </div>
        {/* Digital Resources */}
        <div className="my-8">
          <h3 className="text-2xl font-bold text-black lg:text-4xl font-domine">
            Digital Resources
          </h3>
          <NewArrivalSlide data={libraryApiData?.library?.digital_resource} />
        </div>
        {/* open time & zums library mission vision */}
        <div>
          <div className="grid gap-6 mb-10 lg:mb-16 lg:grid-cols-2">
            <div>
              <h3 className="text-2xl font-bold text-black lg:text-4xl font-domine">
                {libraryApiData?.library?.message_from_librarian?.title}
              </h3>

              <p className="py-6 leading-loose text-gray-700">
                {libraryApiData?.library?.message_from_librarian?.body}
              </p>
              <h5 className="font-bold mt-4 text-lg">
                {libraryApiData?.library?.about_librarian?.title}
              </h5>
              <p> {libraryApiData?.library?.about_librarian?.description}</p>
              <LibraryAmbitionCommitment
                ambition={libraryApiData?.library?.ambition}
                commitment={libraryApiData?.library?.commitment}
              />
            </div>
            <div className="ml-auto w-auto md:w-2/3 aspect-3/4 rounded-lg overflow-hidden">
              <img
                src={libimg}
                alt="Librarian"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
          <div className="">
            <LibraryHours />
          </div>
        </div>
        {/* stats */}
        <LibraryStats stats={libraryApiData?.library?.stats} />
        {/* resources */}
        <div className="relative overflow-hidden ">
          <div className="relative z-10">
            <ResourceGrid
              data={libraryApiData?.library?.e_journal}
              title={"E-Journals"}
            />
          </div>
          <div className="relative z-10">
            <ResourceGrid
              data={libraryApiData?.library?.e_book}
              title={"E-Books"}
            />
          </div>
          <div className="relative z-10">
            <ResourceGrid
              data={libraryApiData?.library?.research_report}
              title={"Online Encyclopedia"}
            />
          </div>
          <div className="relative z-10">
            <ResourceGrid
              data={libraryApiData?.library?.online_encyclopedia}
              title={"Research Support"}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundImage: `url(${bgimage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container grid grid-cols-1 gap-10 px-4 py-12 mx-auto lg:gap-0 sm:px-6 lg:px-8 md:grid-cols-2">
          <div className="z-20 border-gray-200 lg:border-r lg:pr-24">
            <h3 className="text-3xl font-bold text-center text-white font-domine lg:text-4xl">
              {libraryApiData?.library?.become_member[0]?.title}
            </h3>
            <p className="mt-8 text-center text-gray-200">
              {libraryApiData?.library?.become_member[0]?.description}
            </p>

            <div className="flex items-center justify-center w-full mt-8 gap-6 ">
              <a
                href="https://forms.gle/3PmaJvvCJtXEGNiw9"
                target="_blank"
                rel="noopener noreferrer"
                // to={{pathname: "https://forms.gle/3PmaJvvCJtXEGNiw9", state: { external: true }}}
                className={`relative px-6 py-2.5 overflow-hidden font-semibold text-white group `}
              >
                {/* L-shaped border corners */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-0 left-0 w-4 h-full border-l-[3px] border-t-[3px] border-primary"></div>
                  <div className="absolute top-0 right-0 w-4 h-4 border-r-[3px] border-t-[3px] border-primary"></div>
                  <div className="absolute bottom-0 left-0 w-4 h-full border-b-[3px] border-l-[3px] border-primary"></div>
                  <div className="absolute bottom-0 right-0 w-4 h-full border-b-[3px] border-r-[3px] border-primary"></div>
                </div>

                {/* Hover background effect */}
                <div
                  className={`absolute inset-0 group-hover:opacity-100 bg-primary transition-all scale-0 opacity-0 group-hover:scale-100 duration-500 ease-in-out origin-center 
               `}
                ></div>

                {/* Button text */}
                <span className="relative z-10 transition-colors duration-500 ease-in-out group-hover:text-white">
                  Request Membership (Students)
                </span>
              </a>
              <a
                href="https://forms.gle/TtXYoTgPqKew7hok6"
                target="_blank"
                rel="noopener noreferrer"
                // to={libraryApiData?.library?.become_member[0]?.link}
                className={`relative px-6 py-2.5 overflow-hidden font-semibold text-white group `}
              >
                {/* L-shaped border corners */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-0 left-0 w-4 h-full border-l-[3px] border-t-[3px] border-primary"></div>
                  <div className="absolute top-0 right-0 w-4 h-4 border-r-[3px] border-t-[3px] border-primary"></div>
                  <div className="absolute bottom-0 left-0 w-4 h-full border-b-[3px] border-l-[3px] border-primary"></div>
                  <div className="absolute bottom-0 right-0 w-4 h-full border-b-[3px] border-r-[3px] border-primary"></div>
                </div>

                {/* Hover background effect */}
                <div
                  className={`absolute inset-0 group-hover:opacity-100 bg-primary transition-all scale-0 opacity-0 group-hover:scale-100 duration-500 ease-in-out origin-center 
               `}
                ></div>

                {/* Button text */}
                <span className="relative z-10 transition-colors duration-500 ease-in-out group-hover:text-white">
                  Request Membership (Faculty)
                </span>
              </a>
            </div>
          </div>
          <div className="z-20 lg:pl-24">
            <h3 className="text-3xl font-bold text-center text-white font-domine lg:text-4xl">
              {libraryApiData?.library?.book_requisition[0]?.title}
            </h3>
            <p className="mt-8 text-center text-gray-200">
              {libraryApiData?.library?.book_requisition[0]?.description}
            </p>

            <div className="flex items-center justify-center w-full mt-8 ">
              <a
                href="https://forms.gle/5fDnbrKYGytwR9jE9"
                target="_blank"
                rel="noopener noreferrer"
                // to={libraryApiData?.library?.book_requisition[0]?.link}
                className={`relative px-6 py-2.5 overflow-hidden font-semibold text-white group `}
              >
                {/* L-shaped border corners */}
                <div className="absolute inset-0 pointer-events-none">
                  <div className="absolute top-0 left-0 w-4 h-full border-l-[3px] border-t-[3px] border-primary"></div>
                  <div className="absolute top-0 right-0 w-4 h-4 border-r-[3px] border-t-[3px] border-primary"></div>
                  <div className="absolute bottom-0 left-0 w-4 h-full border-b-[3px] border-l-[3px] border-primary"></div>
                  <div className="absolute bottom-0 right-0 w-4 h-full border-b-[3px] border-r-[3px] border-primary"></div>
                </div>

                {/* Hover background effect */}
                <div
                  className={`absolute inset-0 group-hover:opacity-100 bg-primary transition-all scale-0 opacity-0 group-hover:scale-100 duration-500 ease-in-out origin-center 
               `}
                ></div>

                {/* Button text */}
                <span className="relative z-10 transition-colors duration-500 ease-in-out group-hover:text-white">
                  Request Book
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto sm:px-6 lg:px-8">
        {/* rules */}
        <LibraryRules data={libraryApiData?.library?.library_rules} />
      </div>
      <ResearchCTA
        title={libraryApiData?.library?.contact?.title}
        description={libraryApiData?.library?.contact?.description}
        mail={libraryApiData?.library?.contact?.email}
        number={libraryApiData?.library?.contact?.phone}
      />
    </div>
  );
};

export default Library;
